export const SET_LAST_DEPOSIT = 'deposit/SET_LAST_DEPOSIT';
